<template>
  <div id="ServicesPage">
    <div class="container">
      <h1 class="heading brand-secondary">Available Services</h1>
      <div class="text-container">
        <p>Here, you’ll find a range of health and wellbeing services available to you.</p>
        <p>Simply browse the services below, learn more about what each offers, and follow the links to book an appointment or get started right away. Some services are provided directly through this platform, while others connect you to trusted partner organisations.</p>
        <p>Take a step towards better health—explore your services today.</p>
      </div>
      <h2 class="sub-heading brand-secondary">Service Categories</h2>
      <ServiceCategories :selectedCategory='selectedCategory' @selectCategory="selectCategory"/>
      <ServiceList :selectedCategory='selectedCategory'/>
    </div>
  </div>
</template>

<script>
import ServiceCategories from '../components/Services/ServiceCategories.vue';
import ServiceList from '../components/Services/ServiceList.vue';

export default {
  name: "ServicesPage",
  components: {
    ServiceCategories,
    ServiceList
  },
  data() {
    return{
      selectedCategory: {id: 1020234, title: 'All'},
    }
  },
  methods: {
    selectCategory(category) {
      this.selectedCategory = category
    }
  }
}
</script>

<style lang="less">
#ServicesPage {
  padding: 40px 20px;
  background-color: #fff;
  color: #192550;
  max-width: 1190px;
  margin: 0 auto;
  max-width: 100%;
  flex: 1 1 100%;

  .container {
    max-width: 1170px;
    margin: 0 auto;
  }

  .heading {
    font-family: "Raptor V3 Black";
    font-size: 2.6rem;
    margin-bottom: 40px;
  }

  .sub-heading {
    font-family: "Raptor V3 Black";
    font-size: 1.8rem;
    margin-bottom: 28px;
    color: #303030;
  }

  .text-container {
    text-align: center;
    color: #192550;
    font-size: 1.8rem;
    margin-bottom: 40px;
  }
}
</style>